import React from 'react';
import { BadgeDollarSignIcon, ClipboardCheckIcon, HandshakeIcon, RotateCcwIcon, SearchCheckIcon, ZapIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { BENEFITS } from './salesData';
const ICONS = [ZapIcon, ClipboardCheckIcon, SearchCheckIcon, BadgeDollarSignIcon, RotateCcwIcon, HandshakeIcon];

/** Beneficios concretos de usar los scripts mientras atendés. */
export function BenefitsSection() {
  return <section className="w-full bg-mist py-16 sm:py-20" data-id="element-39" data-mp="38udd8ryeq91m">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-6" data-id="element-40" data-mp="3drwqbojdcfrz">
        <div className="max-w-2xl" data-id="element-41" data-mp="2zrlz2ke5cz6a">
          <SectionTag data-id="element-42" data-mp="2zsnl1jwpb62s">Qué cambia</SectionTag>
          <h2 className="mt-4 font-display text-[1.85rem] font-extrabold leading-tight text-ink sm:text-[2.4rem]" data-id="element-43" data-mp="2ztoujjy2jkie">
            Lo que pasa cuando ya tenés el mensaje escrito
          </h2>
        </div>

        <div className="mt-9 grid gap-px overflow-hidden rounded-2xl border border-fog bg-fog sm:grid-cols-2 lg:grid-cols-3" data-id="element-44" data-mp="12z28fpzaimbg">
          {BENEFITS.map((benefit, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <article key={benefit.title} className="flex flex-col bg-white p-5 sm:p-6" data-id="element-45" data-mp="27cstuewg4abb" data-mpi={index}>
                <Icon className="h-6 w-6 text-wa-deep" aria-hidden strokeWidth={2} data-id="element-46" data-mp="2l3xo11h1oae9" />
                <h3 className="mt-4 font-display text-[1.05rem] font-bold leading-snug text-ink" data-id="element-47" data-mp="2g5mcmmb3prtx">
                  {benefit.title}
                </h3>
                <p className="mt-2 font-sans text-[0.9rem] leading-relaxed text-slate" data-id="element-48" data-mp="1sie9a9x8gsuj">
                  {benefit.desc}
                </p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}